/* Tessera: keep the product gallery in sync with the selected colour.

   Dawn already jumps to a variant's assigned image when one exists. This adds:
   - matching a colour name against media alt text / filename when no variant
     image is assigned, and
   - falling back to the product's MAIN image when the selected colour has no
     image of its own. Without that fallback, beige -> blue -> beige left the
     blue photo on screen, because there is no "beige" named image. */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function normalize(s) {
    return (s || '').toLowerCase();
  }

  function colorCandidates(value) {
    var v = normalize(value).trim();
    return [v, v.replace(/\s+/g, '-'), v.replace(/\s+/g, '_'), v.replace(/\s+/g, '')];
  }

  /* The product's first media = its main image. Captured once, before any
     swapping, so it stays a stable "home" to return to. */
  function homeMediaId(gallery) {
    if (!gallery.dataset.tesseraHomeMedia) {
      var first = gallery.querySelector('[data-media-id]');
      if (first) gallery.dataset.tesseraHomeMedia = first.dataset.mediaId;
    }
    return gallery.dataset.tesseraHomeMedia;
  }

  function captureHomeMedia() {
    document.querySelectorAll('product-info media-gallery').forEach(homeMediaId);
  }

  function selectedColor(productInfo) {
    var color = null;
    productInfo.querySelectorAll('input[type="radio"]:checked[data-option-name]').forEach(function (input) {
      if (/^colou?r$|^اللون$/i.test(input.dataset.optionName)) color = input.value;
    });
    if (!color) {
      productInfo.querySelectorAll('select[name^="options["]').forEach(function (select) {
        if (/colou?r|اللون/i.test(select.name)) color = select.value;
      });
    }
    return color;
  }

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function findMediaForColor(gallery, color) {
    var items = gallery.querySelectorAll('[data-media-id]');
    var match = null;

    // 1) curated map (visual analysis of the catalogue) wins
    var handle = productHandle();
    var map = window.TESSERA_COLOR_MAP && handle && window.TESSERA_COLOR_MAP[handle];
    var frag = map && map[normalize(color).trim()];
    if (frag) {
      frag = frag.toLowerCase();
      items.forEach(function (item) {
        if (match) return;
        var img = item.querySelector('img');
        if (img && normalize(img.getAttribute('src')).indexOf(frag) !== -1) match = item;
      });
      if (match) return match;
    }

    // 2) filename / alt-text matching
    var candidates = colorCandidates(color);
    items.forEach(function (item) {
      if (match) return;
      var img = item.querySelector('img');
      if (!img) return;
      var hay = normalize(img.getAttribute('alt')) + ' ' + normalize(img.getAttribute('src'));
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i] && hay.indexOf(candidates[i]) !== -1) {
          match = item;
          return;
        }
      }
    });
    return match;
  }

  /* Put a given photo on screen directly.

     Needed because these product pages render a single media item: Dawn
     switches colour by making another media active, and with nothing to
     switch to the picture never changed. Basic Line showed this plainly -
     ten colours, one photo. */
  function forceMainImage(gallery, url) {
    if (!url) return false;
    var img =
      gallery.querySelector('.product__media-item.is-active img') ||
      gallery.querySelector('.product__media-item img') ||
      gallery.querySelector('img');
    if (!img) return false;
    if ((img.getAttribute('src') || '').split('?')[0] === url.split('?')[0]) return true;
    // srcset would win over src, so it has to go before the swap.
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', url);
    return true;
  }

  function mediaInGallery(gallery, mediaId) {
    var found = null;
    gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
      if (found) return;
      var id = item.dataset.mediaId || '';
      if (id === String(mediaId) || id.slice(-String(mediaId).length - 1) === '-' + mediaId) found = item;
    });
    return found;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data) return;

    var productInfo = null;
    document.querySelectorAll('product-info').forEach(function (el) {
      if (el.dataset.section === data.sectionId) productInfo = el;
    });
    if (!productInfo) return;

    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    // The variant carries its own photo: show it. Activating the media is the
    // tidy route when the gallery holds it; otherwise swap the image itself.
    if (data.variant && data.variant.featured_media) {
      var fm = data.variant.featured_media;
      var item = mediaInGallery(gallery, fm.id);
      if (item && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(item.dataset.mediaId, true);
      } else {
        forceMainImage(gallery, fm.preview_image && fm.preview_image.src);
      }
      return;
    }

    if (typeof gallery.setActiveMedia !== 'function') return;

    var home = homeMediaId(gallery);
    var color = selectedColor(productInfo);
    var match = color ? findMediaForColor(gallery, color) : null;

    if (match) {
      gallery.setActiveMedia(match.dataset.mediaId, true);
    } else if (home) {
      // This colour has no photo of its own -> go back to the main picture.
      gallery.setActiveMedia(home, true);
    }
  });

  /* On load (no ?variant= in the URL), pre-select the colour shown by the main
     image, so the first colour and the main picture agree. */
  function selectColorFromFeaturedImage() {
    captureHomeMedia();
    if (new URLSearchParams(window.location.search).has('variant')) return;

    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var gallery = productInfo.querySelector('media-gallery');
      if (!gallery) return;
      var img =
        gallery.querySelector('.product__media-item.is-active img') ||
        gallery.querySelector('[data-media-id] img');
      if (!img) return;
      var hay = normalize(img.getAttribute('alt')) + ' ' + normalize(img.getAttribute('src'));

      var inputs = [];
      productInfo.querySelectorAll('input[type="radio"][data-option-name]').forEach(function (input) {
        if (/^colou?r$|^اللون$/i.test(input.dataset.optionName)) inputs.push(input);
      });
      if (inputs.length < 2) return;

      // longest names first so "Baby Blue" wins over "Blue"
      var sorted = inputs.slice().sort(function (a, b) {
        return b.value.length - a.value.length;
      });

      var target = null;

      // The curated map pins a colour to a filename, so when the main photo IS
      // one of those files we know which colour it shows even though the name
      // ("1_63.png") carries no colour word. Bed Spreads and Quilts are all
      // like this; without it they opened on colour A showing colour B.
      var cm_handle = productHandle();
      var cm = window.TESSERA_COLOR_MAP && cm_handle && window.TESSERA_COLOR_MAP[cm_handle];
      if (cm) {
        for (var c = 0; c < inputs.length; c++) {
          var cm_frag = cm[normalize(inputs[c].value).trim()];
          if (cm_frag && hay.indexOf(cm_frag.toLowerCase()) !== -1) {
            target = inputs[c];
            break;
          }
        }
      }

      for (var i = 0; !target && i < sorted.length; i++) {
        var cands = colorCandidates(sorted[i].value);
        for (var j = 0; j < cands.length; j++) {
          if (cands[j] && hay.indexOf(cands[j]) !== -1) {
            target = sorted[i];
            break;
          }
        }
        if (target) break;
      }

      // white-family fallback: photo says "white" but the option is Ivory/Off White/Cream
      if (!target && hay.indexOf('white') !== -1) {
        var whiteFamily = ['offwhite', 'ivory', 'cream', 'ecru', 'natural'];
        var famMatches = inputs.filter(function (input) {
          var v = normalize(input.value).replace(/[\s_-]/g, '');
          return whiteFamily.indexOf(v) !== -1 || v === 'white';
        });
        if (famMatches.length === 1) target = famMatches[0];
      }

      if (target && !target.checked) {
        var label = document.querySelector('label[for="' + target.id + '"]');
        if (label) label.click();
        else target.click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      captureHomeMedia();
      setTimeout(selectColorFromFeaturedImage, 100);
    });
  } else {
    captureHomeMedia();
    setTimeout(selectColorFromFeaturedImage, 100);
  }
})();
